var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.084,
    height: 30.086,
    viewBox: "0 0 30.084 30.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "layers",
    d: "M29.935,13.992,25.1,11.576,29.935,9.16a1.176,1.176,0,0,0,0-2.1L16.067.124a1.177,1.177,0,0,0-1.051,0L1.148,7.058a1.176,1.176,0,0,0,0,2.1l4.832,2.416L1.148,13.992a1.176,1.176,0,0,0,0,2.1L5.979,18.51,1.148,20.926a1.176,1.176,0,0,0,0,2.1l13.868,6.934a1.176,1.176,0,0,0,1.051,0l13.868-6.934a1.176,1.176,0,0,0,0-2.1L25.1,18.51l4.832-2.416A1.176,1.176,0,0,0,29.935,13.992ZM15.541,2.489l11.24,5.62-11.24,5.62L4.3,8.109Zm11.24,19.488L15.541,27.6,4.3,21.977l4.306-2.153,6.408,3.2a1.176,1.176,0,0,0,1.051,0l6.408-3.2Zm-11.24-1.314L4.3,15.043,8.607,12.89l6.408,3.2a1.176,1.176,0,0,0,1.051,0l6.408-3.2,4.306,2.153Zm0,0",
    transform: "translate(-0.499 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/projectIcon.67a72eee2eb97fb24930115ab022827f.svg";
export { ForwardRef as ReactComponent };